import { Paper } from "@mui/material"
import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    card: {
        backgroundColor: theme.palette.common.white,
        borderRadius: "1rem",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        boxShadow: theme.shadows[1],
        padding: "1.5rem",
    },
}))

type UsageCardProps = Readonly<PropsWithChildren<{ className?: string }>>

export function UsageCard({ children, className }: UsageCardProps) {
    const { classes, cx } = useStyles()

    return (
        <Paper elevation={0} className={cx(classes.card, className)}>
            {children}
        </Paper>
    )
}
